import { Component, OnDestroy, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { Observable } from 'rxjs/internal/Observable';
import { select, Store } from '@ngrx/store';
import { takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import get from 'lodash.get';
import {
  getBestSellingProducts,
  getLastDealsProducts,
  getConfigCategories,
  getCustomSeoContent,
  getCustomHubPageConfig,
} from '~app/modules/custom-hub/store';
import {
  Hub,
  CustomHubCategory
} from '~app/modules/custom-hub/models';
import { Product, HubPageSeoContent } from '~shared/models';
import { TitleService } from '~shared/services/title.service';
import { NEWSLETTER_PAGE_SOURCE } from '~shared/constants/newsletter-page-source';
import { MEDIA_ALISES } from '~shared/constants/media.constant';


@Component({
  selector: 'app-custom-hub',
  templateUrl: './custom-hub.component.html',
  styleUrls: ['./custom-hub.component.scss']
})
export class CustomHubComponent implements OnInit, OnDestroy {
  isMobile = false;
  isDesktop = false;
  isMobileOrTablet = false;
  hubPageSource = NEWSLETTER_PAGE_SOURCE.HUB_PAGE;

  bestSellingProducts$: Observable<Product[]>;
  lastDealsProducts$: Observable<Product[]>;
  customPageConfig$: Observable<Hub>;
  customPageCategories$: Observable<CustomHubCategory[]>;
  customSeoContent$: Observable<HubPageSeoContent>;

  private unsubscribe$ = new Subject();

    constructor(
      private store: Store,
      private titleService: TitleService,
      private mediaObserver: MediaObserver
  ) {
    }

    ngOnInit(): void {
      this.initializeMediaObservable();

      this.bestSellingProducts$ = this.store.pipe(select(getBestSellingProducts));
      this.lastDealsProducts$ = this.store.pipe(select(getLastDealsProducts));
      this.customPageCategories$ = this.store.pipe(select(getConfigCategories));
      this.customSeoContent$ = this.store.pipe(select(getCustomSeoContent));
      this.customPageConfig$ = this.store.pipe(
        select(getCustomHubPageConfig),
        tap(config => {
          if (get(config, 'title')) {
            this.titleService.setTitle([config.title, { title: 'TITLE.PAGE.CUSTOM_HUB' }]);
          }
        })
      );
    }

    ngOnDestroy() {
      this.unsubscribe$.next();
      this.unsubscribe$.complete();
    }

  private initializeMediaObservable(): void {
      this.mediaObserver.asObservable()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
          this.isMobile = this.mediaObserver.isActive(MEDIA_ALISES.mobile);
          this.isDesktop = this.mediaObserver.isActive(MEDIA_ALISES.desktop);
          this.isMobileOrTablet = this.isMobile || this.mediaObserver.isActive(MEDIA_ALISES.tablet);
        });
    }
  }
